import React from 'react'
import { Text } from '@usap/uicomponents'

const UnitPriceWMO = props => {
  const { itemPriceParsed, multipleItemsPresent } = { ...props }

    return (
      <Text
        color="dark-2"
        style={{
          fontSize: multipleItemsPresent ? "14px" : "12px",
          fontWeight: 400,
          lineHeight: "20px"
        }}
      >
        {'Unit Price: '}
        <Text
          color="dark-2"
          style={{
            fontSize: multipleItemsPresent ? "14px" : "12px",
            fontWeight: multipleItemsPresent ? 600 : 400,
          }}
        >
          $
          {itemPriceParsed.toFixed(2)}
        </Text>
      </Text>
    )
  
}

export default UnitPriceWMO
